import { createSelector } from 'reselect';
import Immutable from 'immutable';
import { getSingularUGCByUsers } from './UGCBaseSelector';

const getTransactions = state => state.getIn(['ugc', 'videosTransactions'], Immutable.Map());

export const getVideosByUsers = getSingularUGCByUsers('videos');

export const getVideosTransactions = createSelector([getTransactions], (transactions) => transactions);

export default {
  getVideosByUsers,
  getVideosTransactions
};



// WEBPACK FOOTER //
// ./app/selectors/ugc/VideosSelector.js